<template>
  <div>
    <div class='header bg-white d-flex align-items-center px-3' style="height: 100px;">
      <img :src="logoImage" alt="ResMed Logo" width="130"/>
    </div>
    
    <main class="d-flex flex-column align-items-center justify-content-center py-5 px-3 text-center" style="min-height: calc(100vh - 120px); background-color: #f5f5f5;">
        <h2 class="h2 font-weight-bold text-dark mb-3">
        This site is not currently in operation.
      </h2>
        <p class="lead text-secondary">
        Please submit proposals for research support to the
        <a
          href="https://www.resmedfoundation.org/"
          target="_blank"
            rel="noopener noreferrer"
            class="text-primary"
          >
          ResMed Foundation
        </a>
        .
      </p>
    </main>
    <div class='footer d-flex align-items-center px-3' style="background-color: #808080; height: 100px;">
      <img :src="whiteLogoImage" alt="ResMed White Logo" width="130" />
    </div>
  </div>
</template>

<script>
import logoImage from '../src/assets/images/resmed_logo.png';
import whiteLogoImage from '../src/assets/images/resmed_white_logo.png';

export default {
  name: 'IIRPage',
  data() {
    return {
      logoImage: logoImage,
      whiteLogoImage: whiteLogoImage,
    };
  }
};
</script>
